import React from 'react';
import PropTypes from 'prop-types';
import FormControl from './FormControl';
import CheckboxControl from './CheckboxControl';
import { CheckboxGroup } from 'react-checkbox-group';
import { simpleArrayMatch } from '../../../Util.js'
import i18n from '../../../i18n/translate';
import { kebabCase } from 'lodash';

export default class CheckboxGroupControl extends FormControl {
  static propTypes = {
    CheckboxComponent: PropTypes.func,
    className: PropTypes.string,
    dataObjectAction: PropTypes.string,
    dataObjectAttribute: PropTypes.string,
    dataObjectId: PropTypes.string,
    dataObjectType: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    labelFunction: PropTypes.func,
    labelKey: PropTypes.string.isRequired,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onValueChange: PropTypes.func,
    readOnlyList: PropTypes.array,
    required: PropTypes.bool,
    selectedClassName: PropTypes.string,
    valueList: PropTypes.array.isRequired,
    valueKey: PropTypes.string.isRequired,
    truncateSize: PropTypes.number
  }

  static defaultProps = Object.assign({}, FormControl.defaultProps, {
    CheckboxComponent: CheckboxControl
  });

  constructor(props) {
    super(props);
    this.state = {
      showMoreValues: props.truncateSize ? false : true,
      value: props.dataValue || []
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.valueOverride) {
      this.syncData(newProps.dataValue || [], true);
    }
  }

  checkboxChange = (value, checked) => {
    let newValue = this.state.value.slice(0);
    let valIndex = this.state.value.findIndex((val) => val === value);
    if (checked && valIndex < 0) {
      newValue.push(value);
    } else if (!checked && valIndex >= 0){
      newValue.splice(valIndex, 1);
    }
    this.syncData(newValue);
  }

  syncData = (newValue, skipValueChange) => {
    if (!simpleArrayMatch(newValue || [], this.state.value)) {
      this.setState({ value: newValue }, () => {
        if (typeof this.props.onValueChange === 'function') {
          this.props.onValueChange({ [this.props.name]: newValue });
        }
        if (typeof this.props.onChange === 'function') {
          this.props.onChange(newValue, skipValueChange);
        }

        this.checkError();
      });
    }
  };

  toggleShowMore = () => {
    this.setState({
      showMoreValues: !this.state.showMoreValues
    })
  }

  isValid = () => {
    return !this.props.required || this.state.value.length;
  }

  checkError() {
    const message = !this.isValid() ? i18n.t("This field is required. Please select at least one option") : null;
    if (typeof this.props.setError === 'function') {
      this.props.setError(!this.isValid(), message);
    }
  }

  render(){
    let { valueList, name, valueKey, labelKey, CheckboxComponent, truncateSize, readOnlyList, dataObjectType, dataObjectAction, dataObjectAttribute } = this.props;
    const readOnlySelected = readOnlyList && readOnlyList.filter(readOnly => this.state.value.includes(readOnly));

    let truncatedData = [];
    if (!Array.isArray(valueList)){
      valueList = [];
    }

    if(truncateSize && valueList && truncateSize < valueList.length) {
      for (let i = 0; i < truncateSize; i++) {
        truncatedData.push(valueList[i]);
      }
    }

    let renderCheckbox = listItem => {
      const itemValue = listItem[valueKey];
      const isSelected = this.state.value.includes(itemValue);

      return (
        <CheckboxComponent
          name={name}
          key={itemValue}
          data-object-action={dataObjectAction || `check-${kebabCase(listItem[labelKey])}`}
          data-object-attribute={dataObjectAttribute}
          data-object-id={itemValue}
          data-object-type={dataObjectType}
          valueOverride={this.props.valueOverride}
          checkboxValue={this.props.useCheckboxValue ? itemValue : undefined}
          label={listItem[labelKey]}
          dataValue={isSelected}
          children={typeof this.props.labelFunction === 'function' ? this.props.labelFunction(listItem) : null}
          className={isSelected ? this.props.selectedClassName : null}
          onChange={checked => this.checkboxChange(itemValue, checked)}
          disabled={this.props.disabled || (readOnlyList && readOnlyList.includes(itemValue))}
          id={this.props.id}
          inline={this.props.inline}
        />
      )
    }

    return (
      <React.Fragment>
        <CheckboxGroup name={name} onChange={this.onChange} value={this.state.value} className={`checkbox-group ${this.props.className || ''}`}>
          {
            this.state.showMoreValues || valueList.length <= truncateSize ?
              valueList.map(renderCheckbox) :
              truncatedData.map(renderCheckbox)
          }
          { truncateSize < valueList.length ?
            <div className="show-more-link">
              <a onClick={this.toggleShowMore} >{this.state.showMoreValues ? i18n.t("Show Less") : i18n.t("Show More")}</a>
            </div> : null}
        </CheckboxGroup>
        {readOnlySelected && readOnlySelected.map(val => <input type="hidden" name={name} value={val} />)}
      </React.Fragment>
    )
  }
}
